export default __webpack_public_path__ + "static/media/3392 - Linsanity.39b15962.jpeg";